// extracted by mini-css-extract-plugin
export default {"container":"donut-chart_container__Nya+g"};